import React from "react";
import closeIcon from "../../Assets/Icons/close.svg";

const projectConsumed = [
    {
        projectName: "Nokia",
        componentUsed: [
            "Bar Graph",
            "Pie Chart",
            "Area Chart",
            "Doughnut Chart",
            "Radar Chart",
            "Line Graph",
            "Stacked Bar"
        ]
    },
    { projectName: "Tfiber", componentUsed: ["Map component"] },
    { projectName: "Philips", componentUsed: ["Grid view and graphs", "Login"] },
    { projectName: "Visteon", componentUsed: ["Graph component"] },
    { projectName: "Qualcomm", componentUsed: ["Grid view", "Graphs"] },
    { projectName: "AHF", componentUsed: ["Login component", "Dashboard"] },
    { projectName: "FHIR", componentUsed: ["Forms"] },
    { projectName: "GenIQ", componentUsed: ["Login"] },
    { projectName: "Smart microgrid", componentUsed: ["3D graphs", "Login component", "3D model viewer"] }
];

const ProjectIntegratedTable = ({ onClose }) => {
    return (
        <div className="fixed inset-0 flex pt-5 justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded shadow-custom text-black w-[90vw] h-[90vh] max-w-6xl border border-gray-600 relative z-20">
                {/* Header */}
                <div className="sticky top-0 bg-[#002746] text-white h-12 flex items-center justify-between px-4 shadow-custom z-10 mb-4">
                    <h1 className="font-semibold text-lg">Project Components Overview</h1>
                    <button
                        onClick={onClose}
                        aria-label="Close"
                        className="border-none hover:bg-slate-700 hover:rounded-full"
                    >
                        <img src={closeIcon} alt="close" className="w-8 h-8" />
                    </button>
                </div>

                {/* Table */}
                <div className="px-4 max-h-[73vh] min-h-[50vh] overflow-y-auto">
                    <table className="bg-white w-full border max-w-[85vw] border-gray-200">
                        <thead className="text-white border-b border-gray-200">
                            <tr className="bg-[#002746] border-b sticky top-[-1px] border-gray-200">
                                <th className="text-left p-2 w-[90px] font-bold">Sr No</th>
                                <th className="text-left p-2 font-bold">Project Name</th>
                                <th className="text-left p-2 font-bold">Components Used</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white text-black">
                            {projectConsumed.map((project, index) => (
                                <tr key={project.projectName} className="border-b hover:bg-gray-100">
                                    <td className="p-2">{index + 1}</td>
                                    <td className="p-2">{project.projectName}</td>
                                    <td className="p-2">
                                        {project.componentUsed.join(", ")}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ProjectIntegratedTable;
